import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./autoBreadcrumbs.module.css";

const AutoBreadcrumbs: React.FC = () => {
    const location = useLocation();

    // Split URL into parts (ex: "/products/corals/lps")
    const pathnames = location.pathname.split("/").filter((x) => x);

    return (
        <nav className={styles.breadcrumbs}>
            <Link to="/">Home</Link>
            {pathnames.map((value, index) => {
                const routeTo = "/" + pathnames.slice(0, index + 1).join("/");

                // Capitalize first letter
                const label = value.charAt(0).toUpperCase() + value.slice(1);

                const isLast = index === pathnames.length - 1;

                return (
                    <span key={routeTo}>
            {" / "}
                        {isLast ? (
                            <span>{label}</span>
                        ) : (
                            <Link to={routeTo}>{label}</Link>
                        )}
          </span>
                );
            })}
        </nav>
    );
};

export default AutoBreadcrumbs;
